import { Button } from '../Button';

interface Props {
    title: string;
    paragraph?: string;
    buttonText?: string;
    onClick?: () => void;
}

export default function NotAvailableOnMobile({ title, paragraph, buttonText, onClick }: Props) {
    return (
        <div className="not-available-on-mobile">
            <img src="/svg/mobile-illustration.svg" alt="not available on mobile" />
            <div className="not-available-on-mobile__content">
                <h1 className="not-available-on-mobile__content--title">{title}</h1>
                {paragraph && <p className="not-available-on-mobile__content--paragraph">{paragraph}</p>}
            </div>
            {buttonText && <Button onClick={onClick} text={buttonText} iconSrc="/svg/common/back-arrow-white.svg" />}
        </div>
    );
}
